<template>
  <div class="buy-set-content pl16 pr16" v-loading="loading">
    <el-form ref="form1" :model="setForm" label-width="180px" size="small">
      <!--通信设置-->
      <div class="common-form">通信设置</div>
      <el-form-item label="最后一次读取时间：">
        {{ parseTime(timestamp) }}
      </el-form-item>
      <el-form-item label="设备协议：" :rules="[{ required: true, message: '设备协议不能为空' }]"
                    prop="PROTOCOL.PROTOCOL_SELECTED_ITEM">
        <el-radio-group v-model="setForm.PROTOCOL.PROTOCOL_SELECTED_ITEM">
          <el-radio :label="'0'">RS232</el-radio>
          <el-radio :label="'1'">RS485</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="RS232协议：" v-if="setForm.PROTOCOL.PROTOCOL_SELECTED_ITEM === '0'"
                    :rules="[{ required: true, message: 'RS232协议不能为空' }]"
                    prop="PROTOCOL.PROTOCOL_232_PRODUCT">
        <el-select v-model="setForm.PROTOCOL.PROTOCOL_232_PRODUCT" placeholder="请选择协议" clearable size="small">
          <el-option v-for="dict in this.getDictDatas(DICT_TYPE.RS232_PROTOCOL)"
                     :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="波特率：" v-if="setForm.PROTOCOL.PROTOCOL_SELECTED_ITEM === '0'"
                    :rules="[{ required: true, message: '波特率不能为空' }]"
                    prop="PROTOCOL.PROTOCOL_232_BAUDRATE">
        <el-select v-model="setForm.PROTOCOL.PROTOCOL_232_BAUDRATE" placeholder="请选择波特率" clearable size="small">
          <el-option v-for="dict in this.getDictDatas(DICT_TYPE.BAUD_RATE)"
                     :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>

      <el-form-item label="RS485协议：" v-if="setForm.PROTOCOL.PROTOCOL_SELECTED_ITEM === '1'"
                    :rules="[{ required: true, message: 'RS485协议不能为空' }]"
                    prop="PROTOCOL.PROTOCOL_485_PRODUCT">
        <el-select v-model="setForm.PROTOCOL.PROTOCOL_485_PRODUCT" placeholder="请选择协议" clearable size="small">
          <el-option v-for="dict in this.getDictDatas(DICT_TYPE.RS485_PROTOCOL)"
                     :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="主从机：" v-if="setForm.PROTOCOL.PROTOCOL_SELECTED_ITEM === '1'"
                    :rules="[{ required: true, message: '主从机不能为空' }]"
                    prop="PROTOCOL.PROTOCOL_485_MASTER_SLAVE">
        <el-radio-group v-model="setForm.PROTOCOL.PROTOCOL_485_MASTER_SLAVE">
          <el-radio v-for="dict in this.getDictDatas(DICT_TYPE.PROTOCOL_485_MASTER_SLAVE)"
                    :key="dict.value" :label="dict.value">{{ dict.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="波特率：" v-if="setForm.PROTOCOL.PROTOCOL_SELECTED_ITEM === '1'"
                    :rules="[{ required: true, message: '波特率不能为空' }]"
                    prop="PROTOCOL.PROTOCOL_485_BAUDRATE">
        <el-select v-model="setForm.PROTOCOL.PROTOCOL_485_BAUDRATE" placeholder="请选择波特率" clearable size="small">
          <el-option v-for="dict in this.getDictDatas(DICT_TYPE.BAUD_RATE)"
                     :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>

      <div class="common-button-wrapper">
        <el-button icon="el-icon-refresh" size="small" type="info" @click="refreshFunction">立即刷新</el-button>
        <el-button icon="el-icon-files" size="small" type="primary" @click="saveFunction">立即保存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import {map} from 'lodash-es';

export default {
  data() {
    return {
      formRules: {},
      timestamp: 0,
      setForm: {
        PROTOCOL: {
          PROTOCOL_232_PRODUCT: '0',
          PROTOCOL_232_BAUDRATE: '9600',
          PROTOCOL_485_PRODUCT: '0',
          PROTOCOL_485_BAUDRATE: '9600',
          PROTOCOL_485_MASTER_SLAVE: 1,
          PROTOCOL_485_ADDRESS: '0',
          PROTOCOL_232_ADDRESS: '0',
          PROTOCOL_HEART_PERIOD: '0',
          PROTOCOL_SELECTED_ITEM: '0'
        }
      },
      /*是否正在加载*/
      loading: false,
    };
  },
  created() {
    let self = this;
    self.refreshFunction();
  },
  inject: ['form'],
  methods: {
    onItemChange(value) {
      this.PROTOCOL.PROTOCOL_SELECTED_ITEM = value
    },
    refreshFunction() {
      let self = this;
      self.loading = true;
      PorductApi.invokeFunction({
        id: self.form.model.id,
        functionId: '$WB_READ',
        convert: true,
        query: {
          "type": Object.keys(self.setForm.PROTOCOL).join(',')
        },
      }, true)
        .then(res => {
          self.loading = false;
          self.$message.success('刷新设备设置信息成功');

          const mData = res.data.split(",");
          Object.keys(self.setForm.PROTOCOL).forEach(function (item, index) {
            self.setForm.PROTOCOL[item] = mData[index]
          })
          self.timestamp = res.timestamp
        })
        .catch(error => {
          self.loading = false;
        });
    },
    saveFunction() {
      let self = this;
      self.loading = true;
      console.log(self.$refs.form1)
      self.$refs.form1.validate(valid => {
        console.log(valid)
        if (valid) {
          PorductApi.invokeFunction({
            id: self.form.model.id,
            functionId: '$WB_WRITE',
            convert: true,
            query: {
              "type": Object.keys(self.setForm.PROTOCOL).join(','),
              "data": Object.values(self.setForm.PROTOCOL).join(',')
            }
          }, true)
            .then(res => {
              self.$message.success('写入设备设置信息成功');
              self.loading = false;
            })
            .catch(error => {
              self.loading = false;
            });
        } else {
          self.loading = false;
        }
      });
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/part/FunctionInvoke.vue